import { TextField, useTheme } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Label,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import api from "../../services/api";
import CustomTooltip from "./CustomTooltip";
import Title from "./Title";
import { toast } from "react-toastify";

const ChartPerUser = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [userChartData, setUserChartData] = useState([]);
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [initialSelectedDate, setInitialSelectedDate] =
    useState(getCurrentDate);
  const [finalSelectedDate, setFinalSelectedDate] = useState(getCurrentDate);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const fetchTicketsPorUsuarios = async () => {
        try {
          const { data } = await api.get("/tickets-por-usuario", {
            params: {
              initialSelectedDate,
              finalSelectedDate,
            },
          });

          setUserChartData(data.ticketsPorUsuario);
        } catch (error) {
          toast.error("Erro ao carregar gráfico de Tickets por Usuário!");
        }
      };

      fetchTicketsPorUsuarios();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [initialSelectedDate, finalSelectedDate]);

  return (
    <React.Fragment>
      <Title>{"Tickets por Usuário"}</Title>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <TextField
          label={"Data inicial"}
          type="date"
          value={initialSelectedDate}
          onChange={(e) => setInitialSelectedDate(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          label={"Data final"}
          type="date"
          value={finalSelectedDate}
          onChange={(e) => setFinalSelectedDate(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </div>
      <ResponsiveContainer>
        <BarChart
          data={userChartData}
          barSize={40}
          width={730}
          height={300}
          margin={{
            top: 16,
            right: 16,
            bottom: 0,
            left: 24,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="userName" stroke={theme.palette.text.secondary} />
          <YAxis stroke={theme.palette.text.secondary}>
            <Label
              angle={270}
              position="left"
              style={{ textAnchor: "middle", fill: theme.palette.text.primary }}
            >
              {t("dashboard.chartPerUser.ticket")}
            </Label>
          </YAxis>
          <Tooltip content={<CustomTooltip />} cursor={true} />
          <Bar dataKey="quantidade" fill={theme.palette.primary.main} />
        </BarChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
};

export default ChartPerUser;
